import { returnVonageAPIdata } from '../../../interfaces/chat';

export async function apiRequestHandler(
  url: string,
  requestOptions: any,
  errorMsg: string,
  apiMethod: string,
): Promise<returnVonageAPIdata> {
  return await fetch(url, requestOptions)
    .then(async (response) => {
      if (response.status === 200) {
        if (apiMethod === 'delete') {
          return {
            status: 200,
          };
        } else {
          const json = await response.json();
          return {
            data: json,
            status: response.status,
          };
        }
      } else if (response.status === 403) {
        return {
          errorMessage: 'invalid_session',
          status: response.status,
        };
      } else {
        return {
          errorMessage: errorMsg,
          status: response.status,
        };
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      return error;
    });
}

export async function addNewVonageAccount(
  sessionId: string,
  accountPayload: addNewVonageAccountPayload,
  accountType: string,
) {
  if (!sessionId || sessionId === '') return;
  const requestOptions = {
    body: JSON.stringify(accountPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  const endpoint = accountType === 'sms' ? 'vonage-sms' : 'vonage-whatsapp';
  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/${endpoint}`,
    requestOptions,
    '',
    'post',
  );
}

export async function getAccountDetails(sessionId: string, connectionId: string) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  const accountType = connectionId.includes('whatsapp') ? 'whatsapp' : 'sms';
  const endpoint = accountType === 'sms' ? 'vonage-sms' : 'vonage-whatsapp';
  const errorMsg = accountType === 'sms' ? 'failed_to_load_vonage_sms' : 'failed_to_load_vonage_whatsapp';

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/${endpoint}/${connectionId}`,
    {
      headers: {
        'x-session-id': sessionId,
      },
    },
    errorMsg,
    'get',
  );
}

export async function deleteAccount(accountId: string, sessionId: string, accountType: string) {
  if (!sessionId || sessionId === '' || !accountId || accountId === '') return;

  const endpoint = accountType === 'sms' ? 'vonage-sms' : 'vonage-whatsapp';
  const errorMsg = accountType === 'sms' ? 'failed_to_remove_vonage_sms' : 'failed_to_remove_vonage_whatsapp';

  return await apiRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/${endpoint}/${accountId}`,
    {
      method: 'DELETE',
      headers: {
        'x-session-id': sessionId,
      },
    },
    errorMsg,
    'delete',
  );
}
